// Generated file : do not modify
export enum FractionDsnTypes
{
  NONE = 0,
  PERMANENT,
  INTERMITTENTS,
  MIXTE
};

export enum FractionDsnGenres
{
  NONE = 0,
  AGETA,
  CLIENT,
  PRESTATAIRE,
  TESE_CEA
};

import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Fraction Dsn
export default class FractionDsn  {
  // Id
  public id: number;
  // Id établissement
  public etablissementId: number;
  // Raison sociale
  public entite: string;
  // Type
  public type: FractionDsnTypes;
  // Genre
  public genre: FractionDsnGenres;
  // Nom
  public nom: string;
  // Prénom
  public prenom: string;
  // Adresse mail
  public mail: string;
  // Téléphone
  public numero: string;
  // Fraction DSN
  public fraction: number;
  // Commande non exécutée
  public failed: boolean;

  constructor() {
    this.id = 0;
    this.etablissementId = 0;
    this.entite = '';
    this.type = FractionDsnTypes.NONE;
    this.genre = FractionDsnGenres.NONE;
    this.nom = '';
    this.prenom = '';
    this.mail = '';
    this.numero = '';
    this.fraction = 0;
    this.failed = false;
  }

  public static fromJson (obj: FractionDsn): FractionDsn {
    const newFractionDsn: FractionDsn = new FractionDsn();
    newFractionDsn.id = obj.id;
    newFractionDsn.etablissementId = obj.etablissementId;
    newFractionDsn.entite = obj.entite;
    newFractionDsn.type = obj.type;
    newFractionDsn.genre = obj.genre;
    newFractionDsn.nom = obj.nom;
    newFractionDsn.prenom = obj.prenom;
    newFractionDsn.mail = obj.mail;
    newFractionDsn.numero = obj.numero;
    newFractionDsn.fraction = obj.fraction;
    newFractionDsn.failed = obj.failed;
    return newFractionDsn;
  }

  public toJsonFractionDsn (): string {
    const json = {
      id: this.id,
      etablissementId: this.etablissementId,
      entite: this.entite,
      type: this.type,
      genre: this.genre,
      nom: this.nom,
      prenom: this.prenom,
      mail: this.mail,
      numero: this.numero,
      fraction: this.fraction,
    }
    return JSON.stringify(json);
  }

  public fromFractionDsn (obj: FractionDsn): void {
    this.id = obj.id;
    this.etablissementId = obj.etablissementId;
    this.entite = obj.entite;
    this.type = obj.type;
    this.genre = obj.genre;
    this.nom = obj.nom;
    this.prenom = obj.prenom;
    this.mail = obj.mail;
    this.numero = obj.numero;
    this.fraction = obj.fraction;
    this.failed = obj.failed;
  }

  public compareFractionDsn (value: FractionDsn): boolean {
    return (this.toJsonFractionDsn() == value.toJsonFractionDsn());
  }

  public cloneFractionDsn (): FractionDsn {
    return FractionDsn.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(fractionDsns: FractionDsn[]) {
  }
}
